import { formatArticleDisplayDate } from '@/utils/articleDisplayDate';
import { formatArticleReadingTime } from '@/utils/articleReadingTime';

export default function NewspaperArticleMeta({
  date,
  className,
  dateClassName,
  separatorClassName,
}) {
  const formattedDate = formatArticleDisplayDate(date);

  return (
    <div className={className}>
      {formattedDate && (
        <span className={dateClassName}>{formattedDate}</span>
      )}
      {formattedDate && separatorClassName && (
        <span className={separatorClassName} aria-hidden="true">•</span>
      )}
    </div>
  );
}

export function NewspaperArticleReadTime({
  article,
  className,
}) {
  return (
    <span className={className}>
      {formatArticleReadingTime(article)}
    </span>
  );
}
